<style>
#editProjectedReceiverModal .v--modal-box.v--modal {
  min-height: 250px !important;
  min-width: 400px !important;
  max-width: 450px !important;
  max-height: 300px !important;
}
#editProjectedReceiverModal .modal__content {
  overflow-y: hidden !important;
}
#editProjectedReceiverModal .v-btn {
  height: 95%;
  width: 100%;
}
#editProjectedReceiverModal .v-btn__content {
  white-space: normal;
}
</style>

<template>
  <Modal
    modalName="editProjectedReceiverModal"
    title="Projektowany odbiorca"
    :buttons="[]"
  >
    <v-layout style="height: 100%">
      <v-flex xs5>
        <v-btn color="success">
          Edytuj parametry projektowanego odbiorcy
        </v-btn>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex xs5>
        <v-btn color="error">
          Usuń projektowanego odbiorcę
        </v-btn>
      </v-flex>
    </v-layout>
  </Modal>
</template>

<script>
import Modal from '../../../shared/Modal';

export default {
  components: {
    Modal
  },
  data: () => ({

  }),
  methods: {

  }

}
</script>


// WEBPACK FOOTER //
// src/components/viewer/modelWat/modals/EditProjectedReceiver.vue